import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-triangle-top"} maskId="square-filled-radius-0-stroke-1-IconArrowTriangleTop"><path d="M3.69092 19.9999H20.309L11.9999 3.38184L3.69092 19.9999Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowTriangleTop;
